import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
// import { createBrowserRouter, RouterProvider, createRoutesFromElements } from 'react-router-dom';
import setupApiResponseInterceptors from './utils/axios-response.interceptor';
import magnusTheme from './theme/magnusTheme';
// import { ConfirmProvider } from './utils/confirm/confirm.provider';

// Set up api response interceptor to handle errors.
setupApiResponseInterceptors(store);

const theme = createTheme({
  typography: {
    fontFamily: [
      'Ubuntu',
    ].join(','),
  },});

  // const router = createBrowserRouter(
  //   createRoutesFromElements(
  //     <App />
  //   )
  // );

  // ReactDOM.createRoot(document.getElementById("root")).render(
  //   <React.StrictMode>
  //     <RouterProvider router={router} />
  //   </React.StrictMode>
  // );

  ReactDOM.render(
  <ThemeProvider theme={theme}>
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={magnusTheme} >
        <BrowserRouter>
          <App />
        </BrowserRouter>
        {/* <React.StrictMode>
          <RouterProvider router={router} />
        </React.StrictMode> */}
      </ThemeProvider >
    </Provider>
  </React.StrictMode>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
